import actions from "./actions";
import {setRequestReducer, setSuccessReducer} from "../helper";

const initState = {
    locationCreateState: false,
    locationCreateResult: {},

    locationImportState: false,
    locationReadState: false,

    locationReadAllState: false,
    locations: [],
    pagination: {},

    locationUpdateState: false,
    locationUpdateResult: {},

    locationArchiveState: false,
    locationArchiveResult: {},

    locationDeleteState: false,

    locationo: {
        code: null,
        name: null,
        street: null,
        city: null,
        state: null,
        postcode: null,
        country_code: null,
        remarks: null,
    },
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.LOCATION_CREATE_REQUEST:
            return setRequestReducer(state, 'locationCreateState');
        case actions.LOCATION_CREATE_SUCCESS:
            return setSuccessReducer(state, 'locationCreateState', {
                locationCreateResult: action.locationo,
            });

        case actions.LOCATION_IMPORT_REQUEST:
            return setRequestReducer(state, 'locationImportState');
        case actions.LOCATION_IMPORT_SUCCESS:
            return setSuccessReducer(state, 'locationImportState');

        case actions.LOCATION_READ_ALL_REQUEST:
            return setRequestReducer(state, 'locationReadAllState');
        case actions.LOCATION_READ_ALL_SUCCESS:
            return setSuccessReducer(state, 'locationReadAllState', {
                locations: action.locations,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });

        case actions.LOCATION_READ_REQUEST:
            return setRequestReducer(state, 'locationReadState');
        case actions.LOCATION_READ_SUCCESS:
            return setSuccessReducer(state, 'locationReadState', {
                locationo: action.locationo,
            });

        case actions.LOCATION_UPDATE_REQUEST:
            return setRequestReducer(state, 'locationUpdateState');
        case actions.LOCATION_UPDATE_SUCCESS:
            return setSuccessReducer(state, 'locationUpdateState');

        case actions.LOCATION_ARCHIVE_REQUEST:
            return setRequestReducer(state, 'locationArchiveState');
        case actions.LOCATION_ARCHIVE_SUCCESS:
            return setSuccessReducer(state, 'locationArchiveState');

        case actions.LOCATION_DELETE_REQUEST:
            return setRequestReducer(state, 'locationDeleteState');
        case actions.LOCATION_DELETE_SUCCESS:
            return setSuccessReducer(state, 'locationDeleteState');

        case actions.LOCATION_CHANGE: { // Partial update
            const location = {
                ...(action.reset ? initState.location : state.location),
                ...action.request,
            };

            return {
                ...state,
                location,
            };
        }
        case actions.LOCATION_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
